import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=64389726&scoped=true"
import script from "./Confirmation.vue?vue&type=script&lang=ts"
export * from "./Confirmation.vue?vue&type=script&lang=ts"
import style0 from "./Confirmation.vue?vue&type=style&index=0&id=64389726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64389726",
  null
  
)

export default component.exports